module Meevo.Plugins.AlertsManager {

    export enum UserFilterEnum {
        ShowAll = 0,
        EmployeeUserLogins,
        UsersOnly
    }

    export enum RefundTypes {
        All = 1,
        Service,
        Product,
        GiftCard,
        Membership
    }

}